import { useDispatch } from 'react-redux';
import { AttentionTriangleIcon } from '@rsos/assets/icons';
import { Button } from '@rsos/base-components';
import { setSelectedTool } from '@rsos/reduxDataStore/src/features/eventPane/eventPaneSlice';
import { setSelectedTab } from '@rsos/reduxDataStore/src/features/eventPane/eventPaneSlice';
import {
  ALI_DISCREPANCY_TOOL,
  TOOLS_TAB,
} from '@rsos/reduxDataStore/src/features/eventPane/eventPaneTabs';
import { AliDiscrepancyToolProperties } from './AliDiscrepancyForm/AliDiscrepancyForm';
import { useDiscrepancySettings } from './settingsHooks';

interface ReportAliDiscrepancyButtonProps {
  originalAddress?: string;
  classOfService?: string;
  phoneNumber?: string;
}

export function ReportAliDiscrepancyButton({
  originalAddress,
  classOfService,
  phoneNumber,
}: ReportAliDiscrepancyButtonProps) {
  const dispatch = useDispatch();
  const { settings, loading } = useDiscrepancySettings();

  if (loading || !settings.enabled) {
    return null;
  }

  const handleReportDiscrepancy = () => {
    // Prepare tool properties with available address data
    const toolProperties: AliDiscrepancyToolProperties = {
      originalAddress,
      classOfService,
      phoneNumber,
    };

    // Switch to Tools tab with ALI Discrepancy form displayed
    dispatch(
      setSelectedTool({
        tool: ALI_DISCREPANCY_TOOL,
        toolProperties,
      }),
    );
    dispatch(setSelectedTab(TOOLS_TAB));
  };

  return (
    <Button
      data-name="report-ali-discrepancy-button"
      onClick={handleReportDiscrepancy}
      btnType="tertiary"
      size="xxsmall"
    >
      <AttentionTriangleIcon width={12} height={12} />
    </Button>
  );
}
